import Program from '@/shared/classes/epg/program/program'

export const filterProgramsByTime = (
    programs: Program[],
    startTimeBoundary: number
) => programs.filter((program) => program.startMilis > startTimeBoundary)
